import * as Sentry from '@sentry/react';
import {
  FieldTextAreaCompact,
  Modal,
  ModalActions,
  ModalContent,
  Pushbutton
} from '@stratumn/atomic';
import to from 'await-to-js';
import { addBotKey } from 'mutations';
import PropType from 'prop-types';
import { useState } from 'react';
import { SpanType, withSpanAsync } from 'tracing';
import { withGqlClient } from 'wrappers';

export const AddBotKeyModal = props => {
  const [key, setKey] = useState('');
  const [submitted, setSubmit] = useState(false);

  const { environment, bot, toggleModal } = props;

  const updateKey = () => {
    withSpanAsync('updateBotKey', SpanType.processing, async () => {
      setSubmit(true);

      const [err] = await to(addBotKey(environment, bot.rowId, key));

      if (err) {
        Sentry.captureException(err);
        setSubmit(false);
      } else {
        toggleModal();
      }

      return {};
    });
  };

  return (
    <Modal
      closeButtonLabel="Cancel"
      handleCollapse={toggleModal}
      title="Add Bot Public Signing Key"
    >
      <ModalContent>
        <FieldTextAreaCompact
          label="Bot public signing Key"
          noResize
          onValueChange={e => setKey(e.target.value)}
          rows={4}
          value={key}
        />
      </ModalContent>
      <ModalActions>
        <Pushbutton onClick={toggleModal}>cancel</Pushbutton>
        <Pushbutton disabled={!key || submitted} onClick={updateKey} primary>
          Add key
        </Pushbutton>
      </ModalActions>
    </Modal>
  );
};

AddBotKeyModal.propTypes = {
  environment: PropType.object.isRequired,
  bot: PropType.object.isRequired,
  toggleModal: PropType.func.isRequired
};

export default withGqlClient(AddBotKeyModal);
